define('InfiniteScroll.Controls.View', [
    'Backbone',
    'Backbone.CompositeView',

    'jQuery',
    'underscore',

    'infinite_scroll_controls.tpl'
], function InfiniteScrollFacetItemsView(
    Backbone,
    BackboneCompositeView,

    jQuery,
    _,

    infiniteScrollControlsTpl
) {
    'use strict';

    return Backbone.View.extend({
        plp: {},

        isLoadingPage: false,

        initialize: function initialize() {
            var self = this;
            this.plp = this.options.plp;

            this.plp.on('InfiniteScroll-beforeRenderPage', function beforeRenderPage() {
                jQuery('.infinite-scroll-btn-holder').html('Loading...');
            });

            this.plp.on('InfiniteScroll-afterRenderPage', function afterRenderPage(options) {
                var pageCount = (self.initialPageNumber - self.numberOfPagesLoaded) + self.initialPageNumber;

                if (pageCount === self.plp.getPagination().pageCount) {
                    self.$el.html('');
                }

                if ((!self.options.isAtTop) && options.pageNumber === self.plp.getPagination().pageCount) {
                    self.$el.html('');
                }

                if (self.options.isAtTop && (options.pageNumber === 1 || options.initialPageNumber === 1)) {
                    self.$el.html('');
                }
            });

            this.plp.on('InfiniteScroll-noResults', function noResults() {
                self.$el.html('');
            });
        },

        template: infiniteScrollControlsTpl,

        events: {
            'click [data-action="load-pages"]': 'loadPage'
        },

        loadPage: function loadPage() {
            var self = this;
            this.plp.cancelableTrigger('InfiniteScroll-loadMorePage', {
                isAtTop: self.options.isAtTop
            });
        },

        getContext: function getContext() {
            var btnText = this.options.isAtTop ?
                this.options.configuration.prevBtnText :
                this.options.configuration.nextBtnText;

            return {
                isButtonBottom: (!this.options.isAtTop),
                showButton: (this.options.isAtTop) || ((!this.options.isAtTop) && (!this.options.configuration.enableAutoScroll)),
                buttonText: _(btnText).translate()
            };
        }
    });
});
